import { getTimeBreakdownColumns, userDetailsColumns, userShiftSummaryColumns } from "@/types/insights/presets/timeManagementWeeklyReportInsightPreset"

export function addPresetColumns (
	columns: unknown[],
	presetParameters: { [key: string]: unknown },
	tenantDefaultStartDayOfWeek: number
): void {
	const startDayOfWeek = presetParameters.startDayOfWeek != null
		? Number(presetParameters.startDayOfWeek)
		: tenantDefaultStartDayOfWeek

	let timeBreakdownColumnIndex = Number(presetParameters.timeBreakdownColumnIndex ?? 1) - 1
	let userShiftSummaryColumnIndex = Number(presetParameters.userShiftSummaryColumnIndex ?? 1) - 1

	// Determine requested (0-based) indices from preset parameters. Respect the relative
	// order of requested indices even when they exceed the current columns length.
	const requestedInserts = [
		{ index: timeBreakdownColumnIndex, items: getTimeBreakdownColumns(startDayOfWeek) },
		{ index: userShiftSummaryColumnIndex, items: userShiftSummaryColumns }
	].filter(i => Number.isFinite(i.index) && i.index >= 0)

	// Insert in descending order of requested index so later positions are inserted first
	// and don't shift the intended positions of earlier inserts. This preserves the relative
	// order between inserts that all requested positions beyond the end.

	requestedInserts.sort((a, b) => b.index - a.index)
	for (const insert of requestedInserts) {
		const effectiveIndex = Math.min(insert.index, columns.length)
		columns.splice(effectiveIndex, 0, ...insert.items)
	}

	// Add user details columns at the start.
	columns.splice(0, 0, ...userDetailsColumns)
}
